<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <!-- 顶部搜索区域 -->
    <div class="global-mb16">
      <y-form
        ref="searchRef"
        :formInfo="formInfo"
        @search="search"
        @selfReset="reset"
      >
        <template #platform>
          <y-shop-by-platform
            ref="yShopByPlatformRef"
            :shopData="shopData"
            @change="shopChange"
          ></y-shop-by-platform>
        </template>
      </y-form>
    </div>
    <!-- 操作按钮栏 -->
    <el-tabs v-model="formDataList.scoresType" @tab-click="switchTab">
      <el-tab-pane label="发放" name="0"></el-tab-pane>
      <el-tab-pane label="消费" name="1"></el-tab-pane>
      <el-tab-pane label="过期" name="2"></el-tab-pane>
      <el-tab-pane label="作废" name="3"></el-tab-pane>
    </el-tabs>
    <!-- 活动列表 -->
    <div class="global-felx-1">
      <y-table
        :tableData="tableData"
        :tableInfo="tableInfo"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: total,
        }"
        @handlePage="handlePage"
      >
        <template #platform="scope">
          <span> {{ $getPlatformNameByValue(scope.row.platform) }} </span>
        </template>
      </y-table>
    </div>
  </div>
</template>

<script>
import { getUpdateRecordPage } from "@/api/memberMessageSystem";
import { isScoresBindList } from "@/api/integralCenter/newMemberSystem";
export default {
  name: "integralRecord",
  components: {},
  data() {
    return {
      total: 0, //总页数
      formDataList: {
        memberId: "",
        // scoresCardId: null, //全渠道会员ID
        changeSource: "", //变更来源
        startScores: "", //积分范围值1
        endScores: "", //积分范围值2
        startUpdateTime: "", //首次入会时间-开始
        endUpdateTime: "", //首次入会时间-截止
        scoresType: 0,
        orderId: null,
        // 页码
        pageNum: 1,
        pageSize: 10,
        platform: "",
        sellerManageId: "",
      },
      // 变更来源
      changeSourceList: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 1,
          label: "会员营销",
        },
        {
          value: 2,
          label: "互动活动",
        },
        {
          value: 3,
          label: "手工调整",
        },
        {
          value: 4,
          label: "积分过期",
        },
        {
          value: 5,
          label: "积分导入",
        },
        {
          value: 6,
          label: "订单赠送",
        },
        {
          value: 7,
          label: "退单扣减",
        },
        {
          value: 8,
          label: "其他",
        },
      ],
      // loading
      talbeLoading: false,
      // 列表数据
      tableData: [],

      formInfo: [
        {
          prop: "platform",
          label: "平台名称：",
          slot: "platform",
        },
        {
          label: "全渠道会员ID：",
          prop: "memberId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "变更来源：",
          prop: "changeSource",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 1,
              label: "会员营销",
            },
            {
              value: 2,
              label: "互动活动",
            },
            {
              value: 3,
              label: "手工调整",
            },
            {
              value: 4,
              label: "积分过期",
            },
            {
              value: 5,
              label: "积分导入",
            },
            {
              value: 6,
              label: "订单赠送",
            },
            {
              value: 7,
              label: "退单扣减",
            },
            {
              value: 8,
              label: "其他",
            },
          ],
        },
        {
          label: "订单ID：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "积分变更值：",
          startKey: "startScores",
          endKey: "endScores",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
        {
          label: "变更时间：",
          startKey: "startUpdateTime",
          endKey: "endUpdateTime",
          type: "DateRange",
          dateType: "datetime",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
        },
      ],
      tableInfo: [
        {
          prop: "memberId",
          label: "全渠道会员ID",
          width: "150px",
        },
        {
          prop: "platform",
          label: "平台",
          slot: "platform",
        },
        {
          prop: "sellerManageName",
          label: "店铺名称",
        },
        {
          prop: "orderId",
          label: "订单ID",
          showOverflowTooltip: true,
        },
        {
          prop: "scoresCount",
          label: "积分变更值",
          align: "right",
        },
        {
          prop: "scoresType",
          label: "变更类型",
          formatter: (row) => {
            if (row.scoresType == 0) {
              return "发放";
            } else if (row.scoresType == 1) {
              return "消费";
            } else if (row.scoresType == 2) {
              return "过期";
            } else if (row.scoresType == 3) {
              return "作废";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "expiryDate",
          label: "过期时间",
        },
        {
          prop: "changeSource",
          label: "变更来源",
          width: "230px",
          formatter: (row) => {
            if (row.changeSource == 1) {
              return "会员营销";
            } else if (row.changeSource == 2) {
              return "互动活动";
            } else if (row.changeSource == 3) {
              return "手工调整";
            } else if (row.changeSource == 4) {
              return "积分过期";
            } else if (row.changeSource == 5) {
              return "积分导入";
            } else if (row.changeSource == 6) {
              return "订单赠送";
            } else if (row.changeSource == 7) {
              return "退单扣减";
            } else if (row.changeSource == 8) {
              return "其他";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "remark",
          label: "备注",
          showOverflowTooltip: true,
        },
        {
          prop: "createTime",
          label: "变更时间",
          width: "175px",
        },
        {
          prop: "currentScores",
          label: "变更后积分",
          type: "tips",
          tipsContent:
            "仅为当前流水变动后的瞬时可用积分，最终可用积分请以会员详情为准。",
          isTipsSlot: true,
          tooltipScale: true,
          align: "right",
        },
      ],
      shopData: [],
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "会员信息管理", "积分变更记录");
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log(this.MemberSystemInfo, "11");
  },
  mounted() {
    // 获取积分列表
    // this.getActivityList();
    this.$refs.searchRef.handleSearch();
    this.getScoresBindList();
  },
  methods: {
    shopChange(platform, shop) {
      this.formDataList.platform = platform;
      this.formDataList.sellerManageId = shop;
    },
    search(obj) {
      for (const key in obj) {
        if (key != "platform") {
          this.formDataList[key] = obj[key];
        }
      }
      this.formDataList.pageNum = 1;
      this.formDataList.pageSize = 10;
      this.getActivityList();
    },
    reset() {
      this.$refs.yShopByPlatformRef.reset();
    },
    switchTab(tab) {
      this.formDataList.scoresType = tab.name;
      this.formDataList.pageNum = 1;
      this.formDataList.pageSize = 10;
      this.getActivityList();
    },
    // 获取店铺列表
    getScoresBindList() {
      let _param = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        pageNum: 1,
        pageSize: 99,
      };
      isScoresBindList(_param).then((res) => {
        if (res.code == 200) {
          this.shopData = res.data.dataList.map((item) => {
            return {
              label: item.shopTitle,
              value: item.channelSellerManageId,
              platform: item.platform,
            };
          });
        }
      });
    },
    // 获取积分列表
    getActivityList() {
      this.talbeLoading = true;
      // this.formDataList.pageNum=1
      // this.formDataList.pageSize=10
      getUpdateRecordPage({
        ...this.formDataList,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
      })
        .then((res) => {
          this.talbeLoading = false;
          if (res.code == 200) {
            this.tableData = res.data.dataList;
            this.total = res.data.pageInfo.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {});
    },
    handlePage(page) {
      this.formDataList.pageNum = page.pageNum;
      this.formDataList.pageSize = page.pageSize;
      this.getActivityList();
    },
    // 分页
    handleSizeChange(val) {
      this.formDataList.pageSize = val;
      this.getActivityList();
    },
    handleCurrentChange(val) {
      this.formDataList.pageNum = val;
      this.getActivityList();
    },
    // 重置
    getClean() {
      this.formDataList = {
        memberId: "",
        // scoresCardId: null, //全渠道会员ID
        changeSource: "", //变更来源
        startScores: "", //积分范围值1
        endScores: "", //积分范围值2
        startUpdateTime: "", //首次入会时间-开始
        endUpdateTime: "", //首次入会时间-截止
        scoresType: "0",
        // 页码
        pageNum: 1,
        pageSize: 10,
      };
      this.getActivityList();
    },
  },
};
</script>